import { const_var, params } from "../../../redux/reducers/reducer";
import { EditloadDefaultBuilding } from "../load_building/loadBuilding";
import * as utils from "../../../redux/reducers/utils";
import * as cuBuilding from "../../../redux/reducers/building_pricing/pricingReducer";
import centerBuildingsWallOptionsHelpers from "../building_wall/centerBuildingsWallOptions.helpers";
import leanToWallOptionHelpers from "../../lean_building_pricing/lenatoWallOptions.helpers";
import { setWainscotDefault } from "../building_color/wainscotColor.helper";

export const showMoreLess = (position) => {
	switch (position) {
		case "frontLeanFront":
			const_var.isFrontLeanFront = !const_var.isFrontLeanFront;
			break;
		case "frontLeanLeft":
			const_var.isFrontLeanLeft = !const_var.isFrontLeanLeft;
			break;
		case "frontLeanRight":
			const_var.isFrontLeanRight = !const_var.isFrontLeanRight;
			break;
		case "backLeanFront":
			const_var.isBackLeanFront = !const_var.isBackLeanFront;
			break;
		case "backLeanLeft":
			const_var.isBackLeanLeft = !const_var.isBackLeanLeft;
			break;
		case "backLeanRight":
			const_var.isBackLeanRight = !const_var.isBackLeanRight;
			break;
		case "leftLeanFront":
			const_var.isLeftLeanFront = !const_var.isLeftLeanFront;
			break;
		case "leftLeanBack":
			const_var.isLeftLeanBack = !const_var.isLeftLeanBack;
			break;
		case "leftLeanLeft":
			const_var.isLeftLeanLeft = !const_var.isLeftLeanLeft;
			break;
		case "centerFront":
			const_var.isCenterFront = !const_var.isCenterFront;
			break;
		case "centerBack":
			const_var.isCenterBack = !const_var.isCenterBack;
			break;
		case "centerRight":
			const_var.isCenterRight = !const_var.isCenterRight;
			break;
		case "centerLeft":
			const_var.isCenterLeft = !const_var.isCenterLeft;
			break;
		case "rightLeanFront":
			const_var.isRightLeanFront = !const_var.isRightLeanFront;
			break;
		case "rightLeanBack":
			const_var.isRightLeanBack = !const_var.isRightLeanBack;
			break;
		case "rightLeanRight":
			const_var.isRightLeanRight = !const_var.isRightLeanRight;
			break;
	}
};

export const editActionAfterPreparingData = (state, data, doorData, roofStyleChange) => {
	const_var.showProcessLoaderchkEdit = false;
	const_var.confirmState = true;
	let updatebuildId = false;
	state.selectedTabKey = "buildsizes";
	let checkHeavySnowVal = const_var.CheckSnowLoadValue == 65 ? 1 : 0;
	const defaultBuilding = data.default_building;
	if (data) {
		for (let i = 0; i < defaultBuilding.length; i++) {
			if (params.building_type_name == defaultBuilding[i].name && checkHeavySnowVal == defaultBuilding[i].heavy_snow) {
				const_var.BuldingIDforReset = defaultBuilding[i].id;
				state.OlddefaultBuilding = defaultBuilding[i].id;
				state.defaultBuilding = defaultBuilding[i].id;
				if (defaultBuilding[i].building_id == params.p_b_t) {
					const_var.isTripleWide = defaultBuilding[i]?.image_name.split(".")[0]?.includes("Triple_Wide") ? true : false;
				}
			}
			if (defaultBuilding[i].heavy_snow == 1 && const_var.CheckSnowLoadValue == 65) {
				const_var.defaultBuildingArr[defaultBuilding[i].id] = defaultBuilding[i];
				if (params.building_type_name == defaultBuilding[i].name) {
					state.OlddefaultBuilding = defaultBuilding[i].id;
				}
				state.defaultBuilding = defaultBuilding[i].id;
			}
			if (defaultBuilding[i].heavy_snow == 0 && const_var.CheckSnowLoadValue != 65) {
				const_var.defaultBuildingArr[defaultBuilding[i].id] = defaultBuilding[i];
				if (params.building_type_name == defaultBuilding[i].name) {
					state.OlddefaultBuilding = defaultBuilding[i].id;
				}
				state.defaultBuilding = defaultBuilding[i].id;
			}

			if (
				const_var.editAPIDataByResponse.data.request_data.building.default_building_image_name != undefined &&
				const_var.editAPIDataByResponse.data.request_data.building.default_building_image_name == defaultBuilding[i].image_name &&
				defaultBuilding[i].heavy_snow == checkHeavySnowVal
			) {
				state.defaultBuilding = defaultBuilding[i].id;
				checkHeavySnowVal = defaultBuilding[i].id;
				updatebuildId = true;
				const_var.BuldingIDforReset = defaultBuilding[i].id;
				state.OlddefaultBuilding = defaultBuilding[i].id;
			}
			if (
				const_var.editAPIDataByResponse.data.request_data.building.default_building_image_name == null &&
				const_var.editAPIDataByResponse.data.request_data.building.building_type == defaultBuilding[i].building_id &&
				defaultBuilding[i].heavy_snow == 0 &&
				checkHeavySnowVal == 0
			) {
				state.defaultBuilding = defaultBuilding[i].id;
				checkHeavySnowVal = defaultBuilding[i].id;
				updatebuildId = true;
				const_var.BuldingIDforReset = defaultBuilding[i].id;
				state.OlddefaultBuilding = defaultBuilding[i].id;
			}
		}
		state.OlddefaultBuilding = const_var.selectedBuildingUniqId;
		const_var.holdDefaultBuildingArr = JSON.parse(JSON.stringify(const_var.defaultBuildingArr));
	}
	if (updatebuildId && state.defaultBuilding != checkHeavySnowVal) {
		state.defaultBuilding = checkHeavySnowVal;
	}
	state.defaultRoof = const_var.TypeEnumINDEX[params.p_r_s];
	for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
		if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
			roofStyleChange(state, i, true, true, "edit");
		}
	}
	if (const_var.editAPIDataByResponse.data.request_data.building.insulation_type != undefined && const_var.editAPIDataByResponse.data.request_data.building.insulation_type.name != undefined) {
		const_var.UpdatedPriceData.insulation_price = const_var.editAPIDataByResponse.data.request_data.building.insulation_price;
		params.p_i_o = const_var.editAPIDataByResponse.data.request_data.building.insulation_type ? const_var.editAPIDataByResponse.data.request_data.building.insulation_type.insulation_id : 0;
		if (const_var.a_p_d_a != undefined && const_var.cbInsulation != undefined && const_var.cbInsulation.find((item) => item.insulation_id == params.p_i_o) == undefined) {
			if (const_var.crmSetting.is_Edit == true && const_var.editAPIDataByResponse.data.request_data.building.insulation_type != undefined) {
				let newName = const_var.cbInsulation.find((item) => item.name.includes(const_var.editAPIDataByResponse.data.request_data.building.insulation_type.name));
				params.p_i_o = newName != undefined ? newName.insulation_id : params.p_i_o;
			}
		}
		const_var.showDefaultInsullation =
			const_var.editAPIDataByResponse.data.request_data.building.insulation_type && const_var.editAPIDataByResponse.data.request_data.building.insulation_type.insulation_id != 0 ? true : false;
		params.p_f_i = true;
		if (const_var.editAPIDataByResponse.data.request_data.building.insulation_type != undefined && const_var.editAPIDataByResponse.data.request_data.building.insulation == "roof_only") {
			params.p_r_o = true;
			params.p_f_i = false;
			params.p_c_i = false;
		} else if (
			const_var.editAPIDataByResponse.data.request_data.building.insulation_type != undefined &&
			(const_var.editAPIDataByResponse.data.request_data.building.insulation == "custom" || const_var.editAPIDataByResponse.data.request_data.building.insulation == "Custom")
		) {
			params.p_r_o = false;
			params.p_f_i = false;
			params.p_c_i = true;
		} else {
			params.p_r_o = params.p_r_o;
			params.p_c_i = params.p_c_i;
		}
		cuBuilding.cP();
	}
	if (
		const_var.editAPIDataByResponse.data.request_data.building.connection_fee_side != undefined /* && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_side != 0 */ ||
		const_var.editAPIDataByResponse.data.request_data.building.connection_fee_end != undefined /* && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_end != 0 */
	) {
		if (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_side != undefined /* && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_side != 0 */) {
			const_var.UpdatedPriceData.connection_fee_side = const_var.editAPIDataByResponse.data.request_data.building.connection_fee_side;
		}
		if (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_end != undefined /* && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_end != 0 */) {
			const_var.UpdatedPriceData.connection_fee_end = const_var.editAPIDataByResponse.data.request_data.building.connection_fee_end;
		}
	}

	if (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_left_front != undefined && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_left_front != 0) {
		const_var.UpdatedPriceData.connection_fee_left_front = const_var.editAPIDataByResponse.data.request_data.building.connection_fee_left_front;
	}
	if (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_right_front != undefined && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_right_front != 0) {
		const_var.UpdatedPriceData.connection_fee_right_front = const_var.editAPIDataByResponse.data.request_data.building.connection_fee_right_front;
	}
	if (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_right_back != undefined && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_right_back != 0) {
		const_var.UpdatedPriceData.connection_fee_right_back = const_var.editAPIDataByResponse.data.request_data.building.connection_fee_right_back;
	}
	if (const_var.editAPIDataByResponse.data.request_data.building.connection_fee_left_back != undefined && const_var.editAPIDataByResponse.data.request_data.building.connection_fee_left_back != 0) {
		const_var.UpdatedPriceData.connection_fee_left_back = const_var.editAPIDataByResponse.data.request_data.building.connection_fee_left_back;
	}

	if (const_var.editAPIDataByResponse.data.request_data.building.entry_points != undefined) {
		const_var.componentPriceUpdateData = const_var.editAPIDataByResponse.data.request_data.building.entry_points;
		cuBuilding.addComponent(state, const_var.editAPIDataByResponse.data.request_data.building);
		cuBuilding.cP(true);
	}

	if (const_var.checkPickThisBuilding && const_var.callMesure) {
	}
};

export const changePorchDimension = (state, value, str, secondParam, checkCustomDimension, roofStyleChange) => {
	if (str == "w" && checkCustomDimension == undefined) {
		state.params.r_f_p_w = parseInt(value);

		if (params.add_left_front_porch == true) {
			const_var.l_f_p_w_arr = [];
			for (i = 5; i <= params.p_w - params.r_f_p_w; i++) {
				const_var.l_f_p_w_arr.push(i);
			}
		}

		if (params.r_f_p_w > params.p_w) {
			params.r_f_p_w = params.p_w;
		}
		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		}
	} else if (str == "l" && checkCustomDimension == undefined) {
		state.params.r_f_p_d = parseInt(value);

		if (params.add_right_back_porch == true) {
			const_var.r_b_p_d_arr = [];
			for (i = 5; i <= params.p_d - params.r_f_p_d; i++) {
				const_var.r_b_p_d_arr.push(i);
			}
		}

		if (state.params.r_f_p_d > state.const_var.arrayendLengthRoof[params.p_r_s] && "Vertical" != state.const_var.TypeEnum[state.params.p_r_s]) {
			state.params.p_r_s = 3;
			for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
				if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
					roofStyleChange(state, i, true, true);
				}
			}
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RoofStyleLength";
		}
	} else if (str == "lfw" && checkCustomDimension == undefined) {
		state.params.l_f_p_w = parseInt(value);

		if (params.add_right_front_porch == true) {
			const_var.r_f_p_w_arr = [];
			for (i = 5; i <= params.p_w - params.l_f_p_w; i++) {
				const_var.r_f_p_w_arr.push(i);
			}
		}

		if (params.l_f_p_w > params.p_w) {
			params.l_f_p_w = params.p_w;
		}

		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		}
	} else if (str == "lfl" && checkCustomDimension == undefined) {
		state.params.l_f_p_d = parseInt(value);

		if (params.add_left_back_porch == true) {
			const_var.l_b_p_d_arr = [];
			for (i = 5; i <= params.p_d - params.l_f_p_d; i++) {
				const_var.l_b_p_d_arr.push(i);
			}
		}

		if (state.params.l_f_p_d > state.const_var.arrayendLengthRoof[params.p_r_s] && "Vertical" != state.const_var.TypeEnum[state.params.p_r_s]) {
			state.params.p_r_s = 3;
			for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
				if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
					roofStyleChange(state, i, true, true);
				}
			}
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RoofStyleLength";
		}
	} else if (str == "lbw" && checkCustomDimension == undefined) {
		state.params.l_b_p_w = parseInt(value);

		if (params.add_right_back_porch == true) {
			const_var.r_b_p_w_arr = [];
			for (i = 5; i <= params.p_w - params.l_b_p_w; i++) {
				const_var.r_b_p_w_arr.push(i);
			}
		}

		if (params.l_b_p_w > params.p_w) {
			params.l_b_p_w = params.p_w;
		}

		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		}
	} else if (str == "lbl" && checkCustomDimension == undefined) {
		state.params.l_b_p_d = parseInt(value);

		if (params.add_left_front_porch == true) {
			const_var.l_f_p_d_arr = [];
			for (i = 5; i <= params.p_d - params.l_b_p_d; i++) {
				const_var.l_f_p_d_arr.push(i);
			}
		}

		if (state.params.l_b_p_d > state.const_var.arrayendLengthRoof[params.p_r_s] && "Vertical" != state.const_var.TypeEnum[state.params.p_r_s]) {
			state.params.p_r_s = 3;
			for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
				if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
					roofStyleChange(state, i, true, true);
				}
			}
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RoofStyleLength";
		}
	} else if (str == "rbw" && checkCustomDimension == undefined) {
		state.params.r_b_p_w = parseInt(value);

		if (params.add_left_back_porch == true) {
			const_var.l_b_p_w_arr = [];
			for (i = 5; i <= params.p_w - params.r_b_p_w; i++) {
				const_var.l_b_p_w_arr.push(i);
			}
		}

		if (params.r_b_p_w > params.p_w) {
			params.r_b_p_w = params.p_w;
		}

		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
		}
	} else if (str == "rbl" && checkCustomDimension == undefined) {
		state.params.r_b_p_d = parseInt(value);

		if (params.add_right_front_porch == true) {
			const_var.r_f_p_d_arr = [];
			for (i = 5; i <= params.p_d - params.r_b_p_d; i++) {
				const_var.r_f_p_d_arr.push(i);
			}
		}

		if (state.params.r_b_p_d > state.const_var.arrayendLengthRoof[params.p_r_s] && "Vertical" != state.const_var.TypeEnum[state.params.p_r_s]) {
			state.params.p_r_s = 3;
			for (var i = 0; i <= const_var.roof_style.length - 1; i++) {
				if (state.const_var.roof_style[i].roof_id == state.params.p_r_s) {
					roofStyleChange(state, i, true, true);
				}
			}
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RoofStyleLength";
		}
	}
};
export const widerlongeranimate = () => {
	document.querySelector("body").classList.add("animate-left-panel");
	setTimeout(function () {
		document.querySelector("body").classList.remove("animate-left-panel");
	}, 1000);
};

export const reSelExtEle = (state, resetBracing = false) => {
	let chkEndJtrim = const_var.a_p_d_a.jtrim?.filter((data) => data.type == "end")?.length > 0 ? true : false;
	let chkSideJtrim = const_var.a_p_d_a.jtrim?.filter((data) => data.type == "side")?.length > 0 ? true : false;

	if (!state.params.p_j_t_end || !chkEndJtrim) state.params.p_j_t_end = false;
	if (!state.params.p_j_t || !chkSideJtrim) state.params.p_j_t = false;

	state.params.p_t_u = state.params.p_e_b = state.params.p_e_t = state.params.p_b_p_feetVal = state.params.p_a_ch = state.params.p_m_h_a = state.params.p_r_a = params.p_p_b = 0;
	if (resetBracing) {
		state.params.added_building_bracing = {
			p_e_c_b_l: false,
			p_s_c_b_l: false,
			p_e_c_b_r: false,
			p_s_c_b_r: false,
			p_e_c_b_f: false,
			p_s_c_b_f: false,
			p_e_c_b_b: false,
			p_s_c_b_b: false
		};
		params.p_s_c_b = params.p_e_c_b = false;
	}
	state.params.risk_cost = state.params.cert_pac_cost = state.params.p_b_p = params.p_g_c = params.p_o_p = false;

	state.params.p_b_p_feet = "Select";
	state.additionalFeaturesArray = [];
	state.additionalFeaturesArrayWithPosition = [];
};

export const updateWainscot = (state) => {
	state.params.p_w_c_n = !state.params.p_w_c_n;

	if (const_var.selSidingOption != undefined) {
		if (const_var.c_m_a[params.p_b_t]?.wainscot_details?.length > 0) {
			setWainscotDefault(state.c_m_a, params, state.const_var.color);
		} else {
			let filterColor = const_var.color.filter((val) => (val.sheet_name != undefined ? val.sheet_name.toLowerCase() == const_var.selSidingOption.toLowerCase() : val));

			if (const_var.selSidingOption != "metal" && const_var.selSidingOption != params.wallTexture) {
				let isColorExsist = filterColor.find((val) => val.image_name && val.image_name.toLowerCase().split(".")[0] == params.wallTexture);
				params.p_w_c_c = isColorExsist != undefined ? isColorExsist.hex_value.replace("#", "0x") : filterColor[0].hex_value.replace("#", "0x");
				params.p_w_c_c_name = isColorExsist != undefined ? isColorExsist.name : filterColor[0].name;
				params.p_w_c_c_id = isColorExsist != undefined ? isColorExsist.id : filterColor[0].id;
				params.wainscotTexture = params.wallTexture;
			} else {
				let isColorExsist = filterColor.find((val) => val.hex_value.replace("#", "0x") == params.p_t_c);
				params.p_w_c_c = isColorExsist ? params.p_t_c : filterColor[0].hex_value.replace("#", "0x");

				params.p_w_c_c_name = isColorExsist ? params.p_t_c_name : filterColor[0].name;
				params.p_w_c_c_id = isColorExsist ? params.p_t_c_id : filterColor[0].id;
				params.wainscotTexture = params.wallTexture;
			}
		}
	} else {
		params.p_w_c_c = params.p_t_c;
		let filterName = const_var.color.filter((item) => {
			if (item.hex_value.replace("#", "0x") == params.p_w_c_c) {
				return item.hex_value;
			}
		});
		if (filterName.length > 0) {
			params.p_w_c_c_name = filterName[0].name;
		}
	}
	cuBuilding.BuildingUpdate(true);
	cuBuilding.cP();
};

export const setDefaultConfiguration = (state, data) => {
	state.selectedTabstate = "buildingtypetab";
	const_var.checkLoadDefaultBuildingRespone = true;
	const_var.hodldEditBuildingData = data.request_data.building;
	const_var.UpdatedPriceData = data.request_data.building;
	const_var.SendAPIBuildingData = const_var.editAPIDataByResponse.data.building_data;
	const_var.a_p_d_a = data.pricing_data;
	const_var.holdPricingResponse = data.pricing_data;
	const_var.cbInsulation = data.pricing_data.insulation;
	if (const_var.crmSetting.is_Edit == true && const_var.a_p_d_a.old_insulation != undefined) {
		const_var.a_p_d_a["old_insulation"] = const_var.a_p_d_a.old_insulation;
	} else {
		const_var.a_p_d_a["old_insulation"] = const_var.cbInsulation;
	}
	state.const_var.tabCountStateDisplay = true;
	state.defaultBuilding = undefined;
	const_var.crmSetting.module_id_string = data.module_id_string;
	for (var i = 0; i <= data.request_data.building.leanto.length - 1; i++) {
		if (data.request_data.building.leanto[i].leanto_type == "1") {
			const_var.newLeanArr["left"] = data.request_data.building.leanto[i];
			const_var.newLeanArr["left"].main_index = i;
			const_var.UpdatedPriceData.leanto[i] = data.request_data.building.leanto[i];
		}
		if (data.request_data.building.leanto[i].leanto_type == "3") {
			const_var.newLeanArr["front"] = data.request_data.building.leanto[i];
			const_var.newLeanArr["front"].main_index = i;
			const_var.UpdatedPriceData.leanto[i] = data.request_data.building.leanto[i];
		}
		if (data.request_data.building.leanto[i].leanto_type == "4") {
			const_var.newLeanArr["back"] = data.request_data.building.leanto[i];
			const_var.newLeanArr["back"].main_index = i;
			const_var.UpdatedPriceData.leanto[i] = data.request_data.building.leanto[i];
		}
		if (data.request_data.building.leanto[i].leanto_type == "2") {
			const_var.newLeanArr["right"] = data.request_data.building.leanto[i];
			const_var.newLeanArr["right"].main_index = i;
			const_var.UpdatedPriceData.leanto[i] = data.request_data.building.leanto[i];
		}
	}
	if (data.request_data.building.display_building_type_name == "Custom Buildings") {
		state.const_var.checkmoreCustomizeFlag = true;
	}
	if (const_var.isFromCompare == true && const_var.discount_Offers_end_date) {
		state.discount_Offers_end_date = const_var.discount_Offers_end_date;
		state.discount_Offers = const_var.discount_Offers;
		state.discount_banner = true;
	}
	if (data?.request_data?.building?.tax_zipcode) {
		state.params.tax_zipcode = data.request_data.building.tax_zipcode;
	} else {
		if (data?.personal_info?.address) {
			let defaultAddressData = data.personal_info.address.filter((item) => item.is_default == 1);
			state.params.tax_zipcode = defaultAddressData.length ? defaultAddressData[0].zipcode : "";
		}
	}
	EditloadDefaultBuilding(state, data.request_data, data.tax, data.building_images, data.personal_info, data.states, data);
};
export const addCustomComponent = (state, event, value, componentName) => {
	state.const_var.CheckDoorForEdit = false;
	state.params.DoorPosOnEdit = "";
	state.params.UpdatedDoorPosOnEdit = "";
	state.params.DoorLocOnEdit = "";
	state.params.DoorRotOnEdit = "";
	state.const_var.StopPRAPI = true;
	if (value !== "CustomFrameout" && componentName !== "Select") {
		state.params.p_a_g_r_u_d_c_s = "Select";
		state.params.p_a_g_r_u_d = "Select";
		state.params.p_w_cc = "Select";
		state.params.p_d_c = "Select";
		const_var.custDM = {};
		//f_r_o_d = "";
	}
	if (value == "CustomFrameout" && componentName != "") {
		state.params.doorType = value;
		state.params.p_a_g_r_u_d = "Select";
		state.params.f_r_m_o_t = "Select";
		state.params.f_r_m_o_t1 = "Select";
		state.params.p_w_cc = "Select";
		state.params.p_d_c = "Select";
		const_var.custDM = {};
		//f_r_o_d = "";
	}
	cuBuilding.cP();
};

export const updateJTrim = (type) => {
	let checkEndJTrim,
		checkSideJTrim = false;
	if (type == "sideJTrim") {
		if (const_var.a_p_d_a.jtrim && const_var.a_p_d_a.jtrim.length > 0) {
			checkSideJTrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "side").length > 0 ? true : false;
		}
		if (checkSideJTrim && ((params.p_r_w != "Open" && params.p_r_w != "Close") || (params.p_l_w != "Open" && params.p_l_w != "Close"))) {
			params.p_j_t = true;
		}
	} else if (type == "endJTrim") {
		if (const_var.a_p_d_a.jtrim && const_var.a_p_d_a.jtrim.length > 0) {
			checkEndJTrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "end").length > 0 ? true : false;
		}
		if (checkEndJTrim && ((params.p_f_w != "Open" && params.p_f_w != "Close") || (params.p_b_w != "Open" && params.p_b_w != "Close"))) {
			params.p_j_t_end = true;
		}
	} else {
		if (const_var.a_p_d_a.jtrim && const_var.a_p_d_a.jtrim.length > 0) {
			checkSideJTrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "side").length > 0 ? true : false;
			checkEndJTrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "end").length > 0 ? true : false;
		}
		if (checkSideJTrim && ((params.p_r_w != "Open" && params.p_r_w != "Close") || (params.p_l_w != "Open" && params.p_l_w != "Close"))) {
			params.p_j_t = true;
		}
		if (
			checkEndJTrim &&
			((params.p_f_w != "Open" && params.p_f_w != "Close" && params.p_f_w != "Half Dutch End" && params.p_f_w != "Half End") ||
				(params.p_b_w != "Open" && params.p_b_w != "Close" && params.p_b_w != "Half Dutch End" && params.p_b_w != "Half End") ||
				(params.p_b_c_b_l_f != "Open" && params.p_b_c_b_l_f != "Close" && params.p_b_c_b_l_f != "Half Dutch End" && params.p_b_c_b_l_f != "Half End") ||
				(params.p_b_c_b_l_b != "Open" && params.p_b_c_b_l_b != "Close" && params.p_b_c_b_l_b != "Half Dutch End" && params.p_b_c_b_l_b != "Half End") ||
				(params.p_b_c_b_b_f != "Open" && params.p_b_c_b_b_f != "Close" && params.p_b_c_b_b_f != "Half Dutch End" && params.p_b_c_b_b_f != "Half End") ||
				(params.p_b_c_b_b_b != "Open" && params.p_b_c_b_b_b != "Close" && params.p_b_c_b_b_b != "Half Dutch End" && params.p_b_c_b_b_b != "Half End") ||
				(params.p_b_c_b_f_f != "Open" && params.p_b_c_b_f_f != "Close" && params.p_b_c_b_f_f != "Half Dutch End" && params.p_b_c_b_f_f != "Half End") ||
				(params.p_b_c_b_f_b != "Open" && params.p_b_c_b_f_b != "Close" && params.p_b_c_b_f_b != "Half Dutch End" && params.p_b_c_b_f_b != "Half End") ||
				(params.p_b_c_b_r_f != "Open" && params.p_b_c_b_r_f != "Close" && params.p_b_c_b_r_f != "Half Dutch End" && params.p_b_c_b_r_f != "Half End") ||
				(params.p_b_c_b_r_b != "Open" && params.p_b_c_b_r_b != "Close" && params.p_b_c_b_r_b != "Half Dutch End" && params.p_b_c_b_r_b != "Half End"))
		) {
			params.p_j_t_end = true;
		}
	}
};
export const updatePorchLengths = (type) => {
	const_var.lengthData.leftLean.porchLength = 0;
	const_var.lengthData.rightLean.porchLength = 0;
	const_var.lengthData.frontLean.porchLength = 0;
	const_var.lengthData.backLean.porchLength = 0;

	if (params.add_left_back_lean_porch) {
		const_var.lengthData.leftLean.porchLength = params.leanB_p_w;
		const_var.lengthData.backLean.porchLength = params.lean_p_w;
	}
	if (params.add_left_front_lean_porch) {
		const_var.lengthData.leftLean.porchLength = params.leanF_p_w;
		const_var.lengthData.frontLean.porchLength = params.lean_p_w;
	}
	if (params.add_left_back_lean_porch && params.add_left_front_lean_porch) {
		const_var.lengthData.leftLean.porchLength = params.leanF_p_w + params.leanB_p_w;
	}
	if (params.add_right_back_lean_porch) {
		const_var.lengthData.rightLean.porchLength = params.leanB_p_w;
		const_var.lengthData.backLean.porchLength = params.leanR_p_w;
	}
	if (params.add_right_front_lean_porch) {
		const_var.lengthData.rightLean.porchLength = params.leanF_p_w;
		const_var.lengthData.frontLean.porchLength = params.leanR_p_w;
	}
	if (params.add_right_back_lean_porch && params.add_right_front_lean_porch) {
		const_var.lengthData.rightLean.porchLength = params.leanF_p_w + params.leanB_p_w;
	}
	if (params.add_right_front_lean_porch && params.add_left_front_lean_porch) {
		const_var.lengthData.frontLean.porchLength = params.lean_p_w + params.leanR_p_w;
	}
	if (params.add_right_back_lean_porch && params.add_left_back_lean_porch) {
		const_var.lengthData.backLean.porchLength = params.lean_p_w + params.leanR_p_w;
	}
};

export const onSubmitState = (state, event) => {
	event.preventDefault();
	if (state.const_var.confirmState == true) {
		state.const_var.confirmStateError = false;
		state.const_var.tabCountDisplay = true;
		const_var.showReportLoading = true;
		state.selectedTabstate = "buildingtypetab";
	} else {
		state.const_var.confirmStateError = true;
		state.const_var.tabCountDisplay = false;
	}
};
export const makeItCustomBuilding = () => {
	const customBuilding = const_var?.building?.find((b) => b?.building_type?.name === "Custom Buildings");
	const customMapId = customBuilding?.building_type?.map_id;
	const customBuildingId = customBuilding?.building_type?.building_id;
	const build = const_var?.defaultBuildingArr?.find((b) => b?.name === const_var?.post_data?.building?.building_type_name);

	if (customMapId) {
		const_var.mapIdforLean = customMapId;

		const_var.hide_price_calculation = 1;
		const_var.hideCompareOption = true;
		params.p_b_t = customBuildingId;
		const_var.isLNTBuildingIsCustom = true;
	}
};
export const hidePriceForGableLeanTos = (state) => {
	if (const_var.leanto_condition_by_mfg?.gable_building_without_pricing == 1 && const_var.isLTBuilding) {
		makeItCustomBuilding();
	} else {
		const_var.hide_price_calculation = const_var?.stateData?.hide_price_calculation;
		const_var.hideCompareOption = false;
		state.const_var.hide_price_calculation = const_var?.stateData?.hide_price_calculation;
		state.const_var.hideCompareOption = false;
	}
};
export const checkChangeDimension = (state, action) => {
	utils.update26GAUpgradePrice();
	if (action.checkCustomDimension != undefined) {
		let p_w = parseInt(action.value);
		let p_d = parseInt(action.secondParam);
		let leanF_p_d = state.params.leanF_p_d;
		let leanB_p_d = state.params.leanB_p_d;
		let lean_p_d = state.params.lean_p_d;
		let leanR_p_d = state.params.leanR_p_d;

		if (p_d > state.const_var.arrayendLengthRoof[params.p_r_s] && "Vertical" != state.const_var.TypeEnum[state.params.p_r_s]) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RoofStyleLength";
		}

		if (state.params.add_left_front_lean_porch == true && state.params.add_right_front_lean_porch == true) {
			leanF_p_d = p_w;
		}

		if (state.params.add_right_back_lean_porch == true && state.params.add_left_back_lean_porch == true) {
			leanB_p_d = p_w;
		}

		if (state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
			lean_p_d = p_d;
		}

		if (state.params.add_right_back_lean_porch == true && state.params.add_right_front_lean_porch == true) {
			leanR_p_d = p_d;
		}
		if (state.params.add_left_front_lean_porch == true && state.params.leantoAlignmentFront != "2" && p_w != leanF_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_front_lean_porch == true && state.params.leantoAlignmentFront != "3" && p_w != leanF_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_left_back_lean_porch == true && state.params.leantoAlignmentBack != "3" && p_w != leanB_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_back_lean_porch == true && state.params.leantoAlignmentBack != "2" && p_w != leanB_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
		if (state.params.add_left_front_lean_porch == true && state.params.leantoAlignmentLeft != "2" && p_d != lean_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_left_back_lean_porch == true && state.params.leantoAlignmentLeft != "3" && p_d != lean_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_front_lean_porch == true && state.params.leantoAlignmentRight != "2" && p_d != lean_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_back_lean_porch == true && state.params.leantoAlignmentRight != "3" && p_d != lean_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	}
	if (action.str == "w" && action.checkCustomDimension == undefined) {
		let p_w = parseInt(action.value);
		let leanF_p_d = params.leanF_p_d;
		let leanB_p_d = state.params.leanB_p_d;

		if (params.leanStyle.right === "gable") {
			let CheckVal = Math.round((state.params.leanR_p_w * Number(state.params.b_l_t_r_pR)) / 12);
			if (state.params.p_h + (p_w * state.params.p_r_p) / 24 < state.const_var.b_m_i_hlean + CheckVal / 2 && state.params.add_right_lean == true) {
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotIncreaseWidth";
			}
		}
		if (params.leanStyle.left === "gable") {
			let CheckVal = Math.round((state.params.lean_p_w * Number(state.params.b_l_t_r_p)) / 12);
			if (state.params.p_h + (p_w * state.params.p_r_p) / 24 < state.const_var.b_m_i_hlean + CheckVal / 2 && state.params.add_left_lean == true) {
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotIncreaseWidth";
			}
		}
		if (params.leanStyle.front === "gable") {
			let CheckVal = Math.round((state.params.leanF_p_w * Number(state.params.b_l_t_r_pF)) / 12);
			if (state.params.p_h + (p_w * state.params.p_r_p) / 24 < state.const_var.b_m_i_hlean + CheckVal / 2 && state.params.add_front_lean == true) {
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotIncreaseWidth";
			}
		}
		if (params.leanStyle.back === "gable") {
			let CheckVal = Math.round((state.params.leanB_p_w * Number(state.params.b_l_t_r_pB)) / 12);
			if (state.params.p_h + (p_w * state.params.p_r_p) / 24 < state.const_var.b_m_i_hlean + CheckVal / 2 && state.params.add_back_lean == true) {
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotIncreaseWidth";
			}
		}
		if (leanF_p_d >= p_w) {
			leanF_p_d = p_w;
		}
		if (leanB_p_d >= p_w) {
			leanB_p_d = p_w;
		}

		if (state.params.add_left_front_lean_porch == true && state.params.add_right_front_lean_porch == true) {
			leanF_p_d = p_w;
		}

		if (state.params.add_right_back_lean_porch == true && state.params.add_left_back_lean_porch == true) {
			leanB_p_d = p_w;
		}

		if (state.params.add_left_front_lean_porch == true && state.params.leantoAlignmentFront != "2" && p_w != leanF_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_front_lean_porch == true && state.params.leantoAlignmentFront != "3" && p_w != leanF_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_left_back_lean_porch == true && state.params.leantoAlignmentBack != "3" && p_w != leanB_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_back_lean_porch == true && state.params.leantoAlignmentBack != "2" && p_w != leanB_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	} else if (action.str == "l" && action.checkCustomDimension == undefined) {
		let p_d = parseInt(action.value);
		let lean_p_d = state.params.lean_p_d;
		if (p_d > state.const_var.arrayendLengthRoof[params.p_r_s] && "Vertical" != state.const_var.TypeEnum[state.params.p_r_s]) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RoofStyleLength";
		}

		if (state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
			lean_p_d = p_d;
		}

		if (state.params.add_left_front_lean_porch == true && state.params.leantoAlignmentLeft != "2" && p_d != lean_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotChangePorch";
		}

		if (state.params.add_left_back_lean_porch == true && state.params.leantoAlignmentLeft != "3" && p_d != lean_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotChangePorch";
		}

		if (state.params.add_right_front_lean_porch == true && state.params.leantoAlignmentRight != "2" && p_d != lean_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotChangePorch";
		}

		if (state.params.add_right_back_lean_porch == true && state.params.leantoAlignmentRight != "3" && p_d != lean_p_d) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotChangePorch";
		}
	} else if (action.str == "h") {
		if (params.leanStyle.right === "gable") {
			let CheckVal = Math.round((state.params.leanR_p_w * Number(state.params.b_l_t_r_pR)) / 12);
			if (action.value + (state.params.p_w * state.params.p_r_p) / 24 < state.const_var.b_m_i_hlean + CheckVal / 2 && state.params.add_right_lean == true) {
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotIncreaseHeight";
			}
		}
		if (params.leanStyle.left === "gable") {
			let CheckVal = Math.round((state.params.lean_p_w * Number(state.params.b_l_t_r_p)) / 12);
			if (action.value + (state.params.p_w * state.params.p_r_p) / 24 < state.const_var.b_m_i_hlean + CheckVal / 2 && state.params.add_left_lean == true) {
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotIncreaseHeight";
			}
		}
		if (params.leanStyle.front === "gable") {
			let CheckVal = Math.round((state.params.leanF_p_w * Number(state.params.b_l_t_r_pF)) / 12);
			if (action.value + (state.params.p_w * state.params.p_r_p) / 24 < state.const_var.b_m_i_hlean + CheckVal / 2 && state.params.add_front_lean == true) {
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotIncreaseHeight";
			}
		}
		if (params.leanStyle.back === "gable") {
			let CheckVal = Math.round((state.params.leanB_p_w * Number(state.params.b_l_t_r_pB)) / 12);
			if (action.value + (state.params.p_w * state.params.p_r_p) / 24 < state.const_var.b_m_i_hlean + CheckVal / 2 && state.params.add_back_lean == true) {
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotIncreaseHeight";
			}
		}
	} else if (action.str == "lean_w") {
		const lean_p_w = parseInt(action.value);
		utils.update26GAUpgradePrice("left");
		if (params.leanStyle.left === "gable") {
			let CheckVal = Math.round((lean_p_w * Number(state.params.b_l_t_r_p)) / 12);
			if (state.params.p_h + (params.p_w * state.params.p_r_p) / 24 < state.const_var.b_m_i_hlean + CheckVal / 2 && state.params.add_left_lean == true) {
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotIncreaseWidth";
			}
		}
		if (state.params.add_left_front_lean_porch != false && state.params.leanF_p_w != lean_p_w) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_left_back_lean_porch != false && state.params.leanB_p_w != lean_p_w) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_front_lean_porch != false && state.params.add_left_front_lean_porch == true && lean_p_w != state.params.leanR_p_w) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_back_lean_porch != false && state.params.add_left_back_lean_porch == true && lean_p_w != state.params.leanR_p_w) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	} else if (action.str == "lean_l") {
		const lean_p_d = parseInt(action.value);
		utils.update26GAUpgradePrice("left");

		if (state.params.add_left_front_lean_porch != false && state.params.leantoAlignmentLeft != "2") {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		} else if (state.params.add_left_front_lean_porch != false && state.params.leantoAlignmentLeft == "2") {
			state.params.lean_p_pos = params.lean_p_pos - (lean_p_d - params.lean_p_d) / 2;
		}

		if (state.params.add_left_back_lean_porch != false && state.params.leantoAlignmentLeft != "3") {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		} else if (state.params.add_left_back_lean_porch != false && state.params.leantoAlignmentLeft == "3") {
			state.params.lean_p_pos = params.lean_p_pos + (lean_p_d - params.lean_p_d) / 2;
		}
	} else if (action.str == "lean_h") {
		const lean_p_h = parseInt(action.value);
		utils.update26GAUpgradePrice("left");

		if (state.params.add_left_front_lean_porch != false && state.params.leanF_p_h != lean_p_h) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_left_back_lean_porch != false && state.params.leanB_p_h != lean_p_h) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_front_lean_porch != false && state.params.add_left_front_lean_porch == true && lean_p_h != state.params.leanR_p_h) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_back_lean_porch != false && state.params.add_left_back_lean_porch == true && lean_p_h != state.params.leanR_p_h) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	} else if (action.str == "leanR_w") {
		const leanR_p_w = parseInt(action.value);
		utils.update26GAUpgradePrice("right");

		if (params.leanStyle.right === "gable") {
			let CheckVal = Math.round((leanR_p_w * Number(state.params.b_l_t_r_pR)) / 12);
			if (state.params.p_h + (params.p_w * state.params.p_r_p) / 24 < state.const_var.b_m_i_hlean + CheckVal / 2 && state.params.add_right_lean == true) {
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotIncreaseWidth";
			}
		}
		if (state.params.add_right_front_lean_porch != false && state.params.leanF_p_w != leanR_p_w) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_back_lean_porch != false && state.params.leanB_p_w != leanR_p_w) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_left_front_lean_porch != false && state.params.add_right_front_lean_porch == true && state.params.lean_p_w != leanR_p_w) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_left_back_lean_porch != false && state.params.add_right_back_lean_porch == true && state.params.lean_p_w != leanR_p_w) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	} else if (action.str == "leanR_l") {
		const leanR_p_d = parseInt(action.value);
		utils.update26GAUpgradePrice("right");
		if (state.params.add_right_front_lean_porch != false && state.params.leantoAlignmentRight != "2") {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		} else if (state.params.add_right_front_lean_porch != false && state.params.leantoAlignmentRight == "2") {
			state.params.leanR_p_pos = params.leanR_p_pos - (leanR_p_d - params.leanR_p_d) / 2;
		}

		if (state.params.add_right_back_lean_porch != false && state.params.leantoAlignmentRight != "3") {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		} else if (state.params.add_right_back_lean_porch != false && state.params.leantoAlignmentRight == "3") {
			state.params.leanR_p_pos = params.leanR_p_pos + (leanR_p_d - params.leanR_p_d) / 2;
		}
	} else if (action.str == "leanR_h") {
		if (state.params.add_right_front_lean_porch != false) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_back_lean_porch != false) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	} else if (action.str == "leanF_w") {
		if (state.params.add_left_front_lean_porch != false) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_front_lean_porch != false) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	} else if (action.str == "leanF_l") {
		const leanF_p_d = parseInt(action.value);
		utils.update26GAUpgradePrice("front");
		if (state.params.add_left_front_lean_porch != false && state.params.leantoAlignmentFront != "2" && leanF_p_d != params.p_w) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		} else if (state.params.add_left_front_lean_porch != false && state.params.leantoAlignmentFront == "2" && leanF_p_d != params.leanF_p_d) {
			state.params.leanF_p_pos = params.leanF_p_pos + (leanF_p_d - params.leanF_p_d) / 2;
		}

		if (state.params.add_right_front_lean_porch != false && state.params.leantoAlignmentFront != "3" && leanF_p_d != params.p_w) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		} else if (state.params.add_right_front_lean_porch != false && state.params.leantoAlignmentFront == "3" && leanF_p_d != params.leanF_p_d) {
			state.params.leanF_p_pos = params.leanF_p_pos - (leanF_p_d - params.leanF_p_d) / 2;
		}
	} else if (action.str == "leanF_h") {
		if (state.params.add_left_front_lean_porch != false) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_front_lean_porch != false) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	} else if (action.str == "leanB_w") {
		if (state.params.add_left_back_lean_porch != false) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_back_lean_porch != false) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	} else if (action.str == "leanB_l") {
		const leanB_p_d = parseInt(action.value);

		utils.update26GAUpgradePrice("back");
		if (state.params.add_left_back_lean_porch != false && state.params.leantoAlignmentBack != "3" && leanB_p_d != params.p_w) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		} else if (state.params.add_left_back_lean_porch != false && state.params.leantoAlignmentBack == "3" && leanB_p_d != params.leanB_p_d) {
			state.params.leanB_p_pos = params.leanB_p_pos + (leanB_p_d - params.leanB_p_d) / 2;
		}

		if (state.params.add_right_back_lean_porch != false && state.params.leantoAlignmentBack != "2" && leanB_p_d != params.p_w) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		} else if (state.params.add_right_back_lean_porch != false && state.params.leantoAlignmentBack == "2" && leanB_p_d != params.leanB_p_d) {
			state.params.leanB_p_pos = params.leanB_p_pos - (leanB_p_d - params.leanB_p_d) / 2;
		}
	} else if (action.str == "leanB_h") {
		if (state.params.add_left_back_lean_porch != false) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_back_lean_porch != false) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	}
	return {
		...state,
		action
	};
};
export const changeBuildingDimensionData = (state, action, changeBuildingDimension, roofStyleChange) => {
	if (
		params.singleSlope == true &&
		(const_var.c_m_a[params.p_b_t].fixed_new_leg_width == undefined || const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length == 0) &&
		((action.str == "h" && parseInt(action.value) - (Number(params.p_r_p) / 12) * params.p_w < const_var.b_m_i_hlean) ||
			(action.str == "w" && params.p_h - (Number(params.p_r_p) / 12) * parseInt(action.value) < const_var.b_m_i_hlean))
	) {
		state.const_var.isShowAlert = true;
		if (action.str == "w") {
			state.const_var.alertUsedFor = "restrictedBuildingHeight";
			action.value = params.p_w;
		}
		if (action.str == "h") {
			state.const_var.alertUsedFor = "restrictedBuildingHeight1";
			action.value = params.p_h;
		}
	} else {
		const_var.fromChangeDimension = true;
		const_var.showDisabledClass = true;
		changeBuildingDimension(state, action.value, action.str, action.secondParam, action.checkCustomDimension, action.valueToSet, action.from, {
			...centerBuildingsWallOptionsHelpers.reducerBindings,
			...leanToWallOptionHelpers.reducerBindings,
			reSelExtEle,
			roofStyleChange,
			updateJTrim
		});
		if (action.str == "w") {
			if (action.value > 40) {
				widerlongeranimate();
			}
		}

		if (action.str == "l") {
			if (action.value > 50) {
				widerlongeranimate();
			}
		}
	}

	return {
		...state,
		action
	};
};
export const checkChangeBuildingRoof = (state, action) => {
	utils.update26GAUpgradePrice();
	if (action.value == "front") {
		let b_l_t_r_pF = parseInt(action.event);
		let p_h = state.params.p_h;
		const_var.UpdatedPriceData.height_price_changed = true;

		utils.update26GAUpgradePrice("front");
		if (state.params.add_front_lean == true) {
			var calHeight = state.params.leanF_p_h + Math.round((state.params.leanF_p_w * b_l_t_r_pF) / 12);
			let frontLeanRoofHeight = calHeight;
			if (calHeight > p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
				p_h = p_h <= frontLeanRoofHeight ? frontLeanRoofHeight : p_h;
			}

			if (calHeight > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
				b_l_t_r_pF = 3;
			}
			var exactVal = Math.floor(p_h - (params.leanF_p_w * b_l_t_r_pF) / 12);

			if (exactVal < 6 && p_h < state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
				p_h = p_h + 1;
			}
		}
		var dataW = Math.floor(((p_h - state.params.leanF_p_h) * 100) / ((b_l_t_r_pF / 12) * 100));
		var newDataW = parseInt(dataW) >= 24 ? 24 : parseInt(dataW);
		var dataH = Math.floor(p_h - (state.params.leanF_p_w * b_l_t_r_pF) / 12);

		if (
			(params.leanStyle.front !== "gable" && (dataH < 6 || newDataW < 6)) ||
			(params.leanStyle.front === "gable" &&
				params.leanF_p_h + (params.leanF_p_w * parseInt(action.event)) / 24 > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height + (params.p_w * params.p_r_p) / 24)
		) {
			b_l_t_r_pF = "2";
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RoofPitchAction";
		}

		if (state.params.add_right_front_lean_porch == true && b_l_t_r_pF != state.params.b_l_t_r_pR) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_left_front_lean_porch == true && b_l_t_r_pF != state.params.b_l_t_r_p) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	}
	if (action.value == "left") {
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		const_var.UpdatedPriceData.height_price_changed = true;

		let b_l_t_r_p = parseInt(action.event);
		let p_h = state.params.p_h;

		utils.update26GAUpgradePrice("left");
		if (state.params.add_left_lean == true) {
			var calHeight = state.params.lean_p_h + Math.round((state.params.lean_p_w * b_l_t_r_p) / 12);
			let leftLeanRoofHeight = calHeight;
			if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
				p_h = p_h < leftLeanRoofHeight ? leftLeanRoofHeight : p_h;
			}
			if (calHeight > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
				b_l_t_r_p = 3;
			}
			var exactVal = Math.floor(p_h - (params.lean_p_w * b_l_t_r_p) / 12);

			if (exactVal < 6 && p_h < state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
				p_h = p_h + 1;
			}
		}
		var dataW = Math.floor(((p_h - state.params.lean_p_h) * 100) / ((b_l_t_r_p / 12) * 100));
		var newDataW = parseInt(dataW) >= 24 ? 24 : parseInt(dataW);
		var dataH = Math.floor(p_h - (state.params.lean_p_w * b_l_t_r_p) / 12);
		let minWidthL = 6;
		let roofDatanew = const_var.roof_style_Barn;
		if (const_var.roof_style_Barn_with_centerbuilding[params.p_b_t] != undefined) {
			roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
		}
		roofDatanew.map((val, i) => {
			if (params.p_r_s == val.roof_id) {
				minWidthL = val.min_width;
			}
		});

		if (
			(params.leanStyle.left !== "gable" && (dataH < 6 || newDataW < minWidthL)) ||
			(params.leanStyle.left === "gable" && params.lean_p_h + (params.lean_p_w * parseInt(action.event)) / 24 > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height + (params.p_w * params.p_r_p) / 24)
		) {
			b_l_t_r_p = "2";
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RoofPitchAction";
		}

		if (state.params.add_left_front_lean_porch != false && b_l_t_r_p != params.b_l_t_r_pF) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_left_back_lean_porch != false && b_l_t_r_p != params.b_l_t_r_pB) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	}
	if (action.value == "right") {
		const_var.UpdatedPriceData.height_price_changed = true;
		let b_l_t_r_pR = parseInt(action.event);
		let p_h = state.params.p_h;

		utils.update26GAUpgradePrice("right");
		if (state.params.add_right_lean == true) {
			var calHeight = state.params.leanR_p_h + Math.round((state.params.leanR_p_w * b_l_t_r_pR) / 12);
			let rightLeanRoofHeight = calHeight;
			if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
				p_h = p_h < rightLeanRoofHeight ? rightLeanRoofHeight : p_h;
			}
			if (calHeight > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
				b_l_t_r_pR = 3;
			}
			var exactVal = Math.floor(params.p_h - (params.leanR_p_w * b_l_t_r_pR) / 12);
			if (exactVal < 6 && p_h < state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
				p_h = p_h + 1;
			}
		}
		var dataW = Math.floor(((p_h - state.params.leanR_p_h) * 100) / ((b_l_t_r_pR / 12) * 100));

		var newDataW = parseInt(dataW) >= 24 ? 24 : parseInt(dataW);
		var dataH = Math.floor(p_h - (state.params.leanR_p_w * b_l_t_r_pR) / 12);
		let minWidthR = 6;
		let roofDatanew = const_var.roof_style_Barn;
		if (const_var.roof_style_Barn_with_centerbuilding[params.p_b_t] != undefined) {
			roofDatanew = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
		}
		roofDatanew.map((val, i) => {
			if (params.p_r_s == val.roof_id) {
				minWidthR = val.min_width;
			}
		});
		if (
			(params.leanStyle.right !== "gable" && (dataH < 6 || newDataW < minWidthR)) ||
			(params.leanStyle.right === "gable" &&
				params.leanR_p_h + (params.leanR_p_w * parseInt(action.event)) / 24 > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height + (params.p_w * params.p_r_p) / 24)
		) {
			b_l_t_r_pR = "2";
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RoofPitchAction";
		}

		if (state.params.add_right_front_lean_porch != false && b_l_t_r_pR != params.b_l_t_r_pF) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_right_back_lean_porch != false && b_l_t_r_pR != params.b_l_t_r_pB) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	}
	if (action.value == "back") {
		let b_l_t_r_pB = parseInt(action.event);
		const_var.UpdatedPriceData.height_price_changed = true;
		let p_h = state.params.p_h;
		utils.update26GAUpgradePrice("back");
		if (state.params.add_back_lean == true) {
			var calHeight = state.params.leanB_p_h + parseInt(b_l_t_r_pB);
			let backLeanRoofHeight = calHeight;
			if (calHeight > state.params.p_h && calHeight <= state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
				p_h = params.p_h < backLeanRoofHeight ? backLeanRoofHeight : state.params.p_h;
			}
			if (calHeight > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
				b_l_t_r_pB = 3;
			}
			var exactVal = Math.floor(params.p_h - (params.leanB_p_w * b_l_t_r_pB) / 12);

			if (exactVal < 6 && p_h < state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height) {
				p_h = p_h + 1;
			}
		}
		var dataW = Math.floor(((p_h - state.params.leanB_p_h) * 100) / ((b_l_t_r_pB / 12) * 100));
		var newDataW = parseInt(dataW) >= 24 ? 24 : parseInt(dataW);
		var dataH = Math.floor(p_h - (state.params.leanB_p_w * b_l_t_r_pB) / 12);
		if (
			(params.leanStyle.back !== "gable" && (dataH < 6 || newDataW < 6)) ||
			(params.leanStyle.back === "gable" &&
				params.leanB_p_h + (params.leanB_p_w * parseInt(action.event)) / 24 > state.const_var.roofObject[params.p_b_t][params.p_r_s].max_height + (params.p_w * params.p_r_p) / 24)
		) {
			b_l_t_r_pB = "2";
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "RoofPitchAction";
		}
		if (state.params.add_right_back_lean_porch == true && b_l_t_r_pB != state.params.b_l_t_r_pR) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}

		if (state.params.add_left_back_lean_porch == true && b_l_t_r_pB != state.params.b_l_t_r_p) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YourCanNotAddPorch";
		}
	}
	if (const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" && const_var.loginSession == false) {
		utils.onWidthHeightChange(params.p_w, params.p_h);
	}
	return {
		...state,
		action
	};
};

export const changeBuildingRoofData = (state, action, changeBuildingRoofHelper) => {
	{
		const p_r_p = action.event.slice(0, 1);
		const manufacturerData = const_var.c_m_a[params.p_b_t];
		const hasManufacturer = manufacturerData !== undefined;
		const fixedLegWidth = manufacturerData?.fixed_new_leg_width;
		const hasFixedLegWidth = fixedLegWidth !== undefined && fixedLegWidth.length > 0;

		const calculatedHeight = params.p_h - (Number(p_r_p) / 12) * params.p_w;

		if (params.singleSlope === true && hasManufacturer && !hasFixedLegWidth && calculatedHeight < const_var.b_m_i_hlean) {
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "restrictedBuildingHeight";
		} else if (params.singleSlope === true && hasManufacturer && hasFixedLegWidth && action.value === "center") {
			state.const_var.isShowAlert = false;
		} else {
			const_var.showDisabledClass = true;
			changeBuildingRoofHelper(state, action.event, action.value);
		}

		return {
			...state,
			newColor: action.event + action.value
		};
	}
};
